import { StyleSheet } from 'aphrodite'

import main from './main'
import table from './table'
import headers from './headers'
import tableRow from './tableRow'
import editable from './editable'
import ColorBlind from './ColorBlind'

export default {
  main: StyleSheet.create(main),
  table: StyleSheet.create(table),
  headers: StyleSheet.create(headers),
  tableRow: StyleSheet.create(tableRow),
  editable: StyleSheet.create(editable),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Settings/partials/SettingsEditor/style/index.js